 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A0_COVER from '@/components/00_cover'
 import A1_PRAISE from '@/components/01_praise'
 import A2_TITLE from '@/components/02_title'
 import A3_COPYRIGHT from '@/components/03_copyright'
 import A4_CONTENTS from '@/components/04_contents'
 import A5_ILLUSTRATIONS from '@/components/05_illustrations'
 import A6_FOREWORD from '@/components/06_foreword'
 import A7_PREFACE from '@/components/07_preface'
 import A8_NOTEONSAFETY from '@/components/08_noteonsafety'
 import A9_CHAPTER01 from '@/components/09_chapter01'
 import A0_CHAPTER02 from '@/components/10_chapter02'
 import A1_CHAPTER03 from '@/components/11_chapter03'
 import A2_CHAPTER04 from '@/components/12_chapter04'
 import A3_CHAPTER05 from '@/components/13_chapter05'
 import A4_CHAPTER06 from '@/components/14_chapter06'
 import A5_CHAPTER07 from '@/components/15_chapter07'
 import A6_CHAPTER08 from '@/components/16_chapter08'
 import A7_CHAPTER09 from '@/components/17_chapter09'
 import A8_CHAPTER10 from '@/components/18_chapter10'
 import A9_CHAPTER11 from '@/components/19_chapter11'
 import A0_CHAPTER12 from '@/components/20_chapter12'
 import A1_CHAPTER13 from '@/components/21_chapter13'
 import A2_CHAPTER14 from '@/components/22_chapter14'
 import A3_CHAPTER15 from '@/components/23_chapter15'
 import A4_APPENDIXI from '@/components/24_appendixi'
 import A5_APPENDIXII from '@/components/25_appendixii'
 import A6_APPENDIXIII from '@/components/26_appendixiii'
 import A7_APPENDIXIV from '@/components/27_appendixiv'
 import A8_APPENDIXV from '@/components/28_appendixv'
 import A9_APPENDIXVI from '@/components/29_appendixvi'
 import A0_BIBLIOGRAPHY from '@/components/30_bibliography'
 import A1_TOOURREADERS from '@/components/31_toourreaders'
 import A2_BACKCOVER from '@/components/32_backcover'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/04_contents",
 			"name" : "04_contents",
 			"component" : A4_CONTENTS
 		},
 		{
 			"path" : "/05_illustrations",
 			"name" : "05_illustrations",
 			"component" : A5_ILLUSTRATIONS
 		},
 		{
 			"path" : "/06_foreword",
 			"name" : "06_foreword",
 			"component" : A6_FOREWORD
 		},
 		{
 			"path" : "/07_preface",
 			"name" : "07_preface",
 			"component" : A7_PREFACE
 		},
 		{
 			"path" : "/08_noteonsafety",
 			"name" : "08_noteonsafety",
 			"component" : A8_NOTEONSAFETY
 		},
 		{
 			"path" : "/09_chapter01",
 			"name" : "09_chapter01",
 			"component" : A9_CHAPTER01
 		},
 		{
 			"path" : "/10_chapter02",
 			"name" : "10_chapter02",
 			"component" : A0_CHAPTER02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js